var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M170.667 128h682.667q53 0 90.5 37.5t37.5 90.5v512q0 53-37.5 90.5t-90.5 37.5h-682.667q-53 0-90.5-37.5t-37.5-90.5v-512q0-53 37.5-90.5t90.5-37.5zM896 768v-466l-357.333 286q-11.333 9.333-26.667 9.333t-26.667-9.333l-357.333-286v466q0 17.667 12.5 30.167t30.167 12.5h682.667q17.667 0 30.167-12.5t12.5-30.167zM853.333 213.333h-682.667q-6.333 0-14 2.333l355.333 284.333 355.333-284.333q-7.667-2.333-14-2.333z"}));
}

Email.displayName = "Email";

Email.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = Email;

Email.default = Email;
